import { NewsDetail, NewsList } from '~/types/News';

export interface NewsApi {
  registerNews: (contentData: NewsDetail) => Promise<{ id: number }>;
  updateNews: (contentData: NewsDetail) => Promise<{ id: number }>;
  fetchNewsList: (page: number, size?: number) => Promise<NewsList>;
  fetchNewsDetail: (contentId: number, requestType: 'card' | 'detail') => Promise<NewsDetail>;
  fetchNewsBody: (url: string) => Promise<any>;
}

export const useNewsApi = (fetch): NewsApi => {
  /** お知らせ一覧の取得 */
  const fetchNewsList = async (page: number, size = 10): Promise<NewsList> => {
    const queryParams = new URLSearchParams({ page: page.toString(), size: size.toString() });
    const response = await fetch(`/news/portal/list/?${queryParams}`);
    return response.data;
  };

  /** お知らせ詳細の取得 */
  const fetchNewsDetail = async (
    contentId: number,
    requestType: 'card' | 'detail',
  ): Promise<NewsDetail> => {
    const queryParams = new URLSearchParams({ requestType });
    const response = await fetch(`/news/${contentId}?${queryParams}`);
    return response.data;
  };

  /** お知らせの登録 */
  const registerNews = async (contentData: NewsDetail): Promise<{ id: number }> => {
    const response = await fetch('/news/create', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(contentData),
    });
    return response.data;
  };

  /** お知らせの更新 */
  const updateNews = async (contentData: NewsDetail): Promise<{ id: number }> => {
    const response = await fetch('/news/update', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(contentData),
    });
    return response.data;
  };

  const fetchNewsBody = async (url: string): Promise<any> => {
    const response = await fetch(url);

    return response.data;
  };

  return {
    registerNews,
    updateNews,
    fetchNewsList,
    fetchNewsDetail,
    fetchNewsBody,
  };
};
